/* eslint-disable */

import Vue from 'vue';
import Vuex from 'vuex'
import Inputmask from "inputmask";

Vue.use(Vuex)
import store from './store';

// Vue.component('inn-search', () => import('./components/InnSearch'));
// import PopupMessage from './components/PopupMessage.vue';

Vue.component('popup-message', () => import('./components/PopupMessage.vue'));
Vue.component('registration-form', () => import('./components/RegistrationForm'));
Vue.component('events-calendar', () => import('./components/EventsCalendar'));
Vue.component('available-support', () => import('./components/AvailableSupport'));
Vue.component('btn-more', () => import('./components/BtnMore'));
Vue.component('yandex-map', () => import('./components/YandexMap'));
Vue.component('calc', () => import('./components/Calc'));
Vue.component('agro-test', () => import('./components/AgroTest'));

import SearchAutocomplete from './components/SearchAutocomplete.vue';
Vue.component('search-autocomplete', SearchAutocomplete);

window.app = new Vue({
    el : '.app-container',
    store,
    mounted () {
        if (typeof(xpageReady) == 'function') {
            xpageReady();
        }
        $(document).on('submit', 'form[name="iblock_add"]', e => {
            if ($(e.target).hasClass('processed')) {
                e.preventDefault();
                return false;
            }
            $(e.target).addClass('processed');
        });
        document.querySelectorAll(`
            [name="PROPERTY[363][0]"]
        `).forEach(input => {
            input.value = location.href;
            $(input).closest('.form__inputs-input').hide();
        });
        let phoneMask = new Inputmask('+7 (999) 999-99-99');
        let phoneInputNames = [
            48,15,23,43,130,161,176,195,229,246,
            252,258,266,274,282,290,298,306,314,
            322,330,338,346,354,361,367,375,383,
            391,399,407,415,423,431,445,455,477,
            574,568,541,581,562,623,675,682,716,
            754,761,766,771,776,
        ].map(propId => `[name="PROPERTY[${propId}][0]"]`);
        phoneInputNames.push('.mask--phone');
        document.querySelectorAll(phoneInputNames.join(',')).forEach(input => {
            if (input.inputmask) {
                return;
            }
            if (input.value) {
                input.value = input.value.slice(1);
            }
            phoneMask.mask(input);
        });
        $(document).on('focus', phoneInputNames.join(','), e => {
            if (e.target.inputmask) {
                return;
            }
            if (e.target.value) {
                e.target.value = e.target.value.slice(1);
            }
            phoneMask.mask(e.target);
        });
    },
    computed : {
        /*recaptchaSiteKey () {
            return this.$store.state.recaptchaSiteKey;
        },*/
        reachedYaCounterGoalId () {
            return this.$store.state.reachedYaCounterGoalId;
        },
    },
    watch : {
        recaptchaSiteKey (val, oldVal) {
            this.initRecaptcha();
        },
        reachedYaCounterGoalId (goalId, oldVal) {
            if (goalId) {
                if (typeof(window.yaCounter44802325) != 'undefined') {
                    window.yaCounter44802325.reachGoal(goalId);
                }
                else {
                    $(document).on('yacounter44802325inited', () => {
                        window.yaCounter44802325.reachGoal(goalId);
                    });
                }
            }
        },
    },
    methods : {
        initMap (callback) {
            if (!window.ymaps) {
                var script = document.createElement('script');
                script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
                if (typeof(callback) == 'function') {
                    script.onload = callback;
                }
                document.body.appendChild(script);
            }
            else {
                if (typeof(callback) == 'function') {
                    callback();
                }
            }
        },
        initRecaptcha (callback) {
            var script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=${this.$store.state.recaptchaSiteKey}`;
            script.onload = () => {
                grecaptcha.ready(() => {
                    $('form').on('click', e => {
                        var $form = $(e.currentTarget);
                        var $input = $form.find('[name="recaptcha_token"]');
                        var action = $input.data('action-id');
                        if (!$input.val() && !$input.hasClass('recaptcha-processed')) {
                            $input.addClass('recaptcha-processed');
                            grecaptcha.execute(this.$store.state.recaptchaSiteKey, {
                                action,
                            }).then(token => {
                                $($input).val(token);
                            });
                        }
                    });
                });
            };
            document.body.appendChild(script);
        },
    },
});
